module.exports = __webpack_public_path__ + "img/top-list-left1.75db3cf7.png";